<template>
  <div>
    <apexchart
      type="area"
      height="246"
      :options="computedOptions"
      :series="series"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { defineProps } from "vue";

const props = defineProps({
  series: {
    type: Array,
    required: true,
    default: () => [],
  },
  categories: {
    type: Array,
    required: true,
    default: () => [],
  },
  title: {
    type: String,
    required: false,
  },
  color1: {
    type: String,
    required: true,
  },
  color2: {
    type: String,
    required: false,
  },
  dashArray: {
    type: Array,
    required: false,
    default: () => [0, 4],
  },
});

/**
 * Returns a brand-new object every time any dependency (categories,
 * dashArray, colors…) changes, which forces the ApexCharts Vue
 * wrapper to call updateOptions() and re-render the chart.
 */
const computedOptions = computed(() => ({
  chart: {
    type: "area",
    height: 246,
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  stroke: {
    curve: "smooth",
    width: [1, 1],
    dashArray: [...props.dashArray],
  },
  fill: {
    type: "gradient",
    gradient: {
      shade: "light",
      type: "vertical",
      shadeIntensity: 0.4,
      opacityFrom: 0.5,
      opacityTo: 0,
      stops: [0, 100],
    },
  },
  markers: {
    size: 0,
  },
  dataLabels: {
    enabled: false,
  },
  xaxis: {
    categories: [...props.categories],
    // title: {
    //   text: "Months"
    // },
    tickPlacement: "on",
  },
  yaxis: {
    title: {
      text: props.title,
    },
  },
  tooltip: {
    enabled: true,
    shared: true,
    intersect: false,
    marker: {
      show: false,
    },
    x: {
      show: false,
    },
  },
  grid: {
    show: false,
  },
  legend: {
    show: false,
  },
  colors: [props.color1, props.color2],
}));
</script>

<style></style>
